import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../../../../constants/common'
import { useKeyboard } from '../../../../../../hooks'
import { ConfirmationModal } from '../../../../../Confirmation'
import Text from '../../../../../Text'
import { TextareaElement } from '../../../../../Textarea'
import {
  APPLICANT_DECISION_NOTE_MAX_LENGTH,
  APPLICANT_DECISION_NOTE_PLACEHOLDER_KEY,
  QA_NAME_APPLICANT_DECISION_MODAL,
  QA_NAME_APPLICANT_DECISION_NOTE_INPUT,
} from '../ApplicantDecisionPanel.constants'
import {
  getApplicantDecisionConfirmProps,
  getApplicantDecisionModalNotifications,
  getIsApplicantDecisionReasonRequired,
} from '../ApplicantDecisionPanel.utils'

import * as styles from '../ApplicantDecisionPanel.module.css'

function ApplicantDecisionModal({ action, applicantData, onClose, onSubmit }) {
  const { t } = useTranslation()

  const [note, setNote] = useState(EMPTY_STRING)

  const [hasError, setError] = useState(false)

  useKeyboard(null, onClose)

  const confirmProps = getApplicantDecisionConfirmProps({
    action,
    applicantData,
    t,
  })

  const isReasonMissing =
    getIsApplicantDecisionReasonRequired(action) && !note.trim()

  async function handleSubmit() {
    setError(false)

    try {
      await onSubmit(note.trim() || null)
    } catch {
      setError(true)
    }
  }

  const notifications = getApplicantDecisionModalNotifications({
    action,
    hasError,
    t,
  })

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitProps: {
          disabled: isReasonMissing,
          tooltip: isReasonMissing
            ? t('RentalPortal.ApplicantDecisionReasonRequiredTooltipKey')
            : null,
        },
        submitText: confirmProps.submitText,
      }}
      description={confirmProps.description}
      notifications={notifications}
      notificationsProps={{ notifications }}
      qaName={QA_NAME_APPLICANT_DECISION_MODAL}
      title={confirmProps.title}
      onCancel={onClose}
      onSubmit={handleSubmit}
    >
      <div className={styles.modalBody}>
        <TextareaElement
          autoResizeHeight
          focused
          maxLength={APPLICANT_DECISION_NOTE_MAX_LENGTH}
          placeholder={t(APPLICANT_DECISION_NOTE_PLACEHOLDER_KEY[action])}
          qaName={QA_NAME_APPLICANT_DECISION_NOTE_INPUT}
          value={note}
          onChange={setNote}
        />
        <Text isSecondary className={styles.modalGuardrail}>
          {t('RentalPortal.ApplicantDecisionNoteGuardrailKey')}
        </Text>
      </div>
    </ConfirmationModal>
  )
}

export default ApplicantDecisionModal
